import { render, staticRenderFns } from "./inventoryRulesForm.vue?vue&type=template&id=a8a9cf8e&scoped=true&"
import script from "./inventoryRulesForm.vue?vue&type=script&lang=js&"
export * from "./inventoryRulesForm.vue?vue&type=script&lang=js&"
import style0 from "./inventoryRulesForm.vue?vue&type=style&index=0&id=a8a9cf8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a9cf8e",
  null
  
)

export default component.exports